import * as Unicons from '@iconscout/react-unicons';
import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { SidebarMenuItems } from '../../types/sidebarMenuItems';
import { Avatar } from '../Avatar';
import { Hamburger } from '../Hamburger';
import SidebarItem from '../SidebarItem/SidebarItem';
import { LanguageDropdown } from './change-language-menu';
import './sidebar.scss';
import useSidebarComponentState from './useSidebarComponentState';

interface SidebarProps {
  cursos?: boolean;
  webinars?: boolean;
  conectas?: boolean;
  gestaoSalaAula?: boolean;
  materiais?: boolean;
  mentorias?: boolean;
  instrutor?: boolean;
  profile?: boolean;
  ferramentas?: boolean;
  materiaisApoio?: boolean;
  minhasAulasHappy?: boolean;
}

export const Sidebar = ({
  instrutor,
  materiais,
  cursos,
  webinars,
  conectas,
  gestaoSalaAula,
  profile,
  ferramentas,
  materiaisApoio,
  minhasAulasHappy
}: SidebarProps) => {
  const {
    logout,
    hamburgerOpen,
    menuBurger,
    toggleHamburger,
    menuIconClick,
    menuIsOpen,
    usuario,
    isPermissionamentoMaterial,
    isPermissionamentoGestaoSala,
    isPermissionamentoConecta,
    iconButton,
    happyLogo,
    isB2bOnly,
    unidade

  } = useSidebarComponentState();

  const hamburgerComponent = {
    isOpen: hamburgerOpen,
    onClick: toggleHamburger,
    menuHamburguerClass: menuBurger,
    isPermissionamentoConecta: isPermissionamentoConecta,
    isPermissionamentoMaterial: isPermissionamentoMaterial,
    isPermissionamentoGestaoSala: isPermissionamentoGestaoSala,
  };
  const { t } = useTranslation(['common', 'menu']);



  const menuItems: SidebarMenuItems[] = [
    {
      active: instrutor,
      link: '/instrutor',
      label: t('menu:home'),
      icon: <Unicons.UilHome />,
      userCanView: true,
    },
    {
      active: cursos,
      link: '/cursos',
      label: t('menu:training'),
      icon: <Unicons.UilGraduationCap />,
      userCanView: true,
    },
    {
      active: webinars,
      link: '/webinars/all',
      label: t('menu:webinars'),
      icon: <Unicons.UilBookmark />,
      userCanView: true,
    },
    {
      active: conectas,
      link: '/conectas/all',
      label: t('menu:conecta'),
      icon: <Unicons.UilPlug />,
      userCanView: false,
    },
    {
      active: materiais,
      link: '/materiais',
      label: t('menu:learningMaterials'),
      icon: <Unicons.UilBookReader />,
      userCanView: isPermissionamentoMaterial,
    },
    {
      active: gestaoSalaAula,
      link: '/turmas',
      label: t('menu:classroomManagement'),
      icon: <Unicons.UilGrid />,
      userCanView: isPermissionamentoGestaoSala,
    },
    {
      active: materiaisApoio,
      link: '/materiais-de-apoio',
      label: t('menu:supportMaterials'),
      icon: <Unicons.UilFolder />,
      userCanView: true,
    },
    {
      active: ferramentas,
      link: '/ferramentas',
      label: t('menu:tools'),
      icon: <Unicons.UilWrench />,
      userCanView: true,
    },
    {
      active: minhasAulasHappy,
      link: '/minhas-aulas-happy',
      label: t('menu:myHappyClasses'),
      icon: <Unicons.UilDownloadAlt />,
      userCanView: isB2bOnly,
    }

  ];

  return (
    <>
      <Hamburger {...hamburgerComponent} />
      <aside className="sidebar-wrapper">
        <div className="sidebar-wrapper__logo-container">
          <img
            alt="Happy Logo images"
            src={happyLogo}
            onClick={menuIconClick}
          />
          <Button
            onClick={menuIconClick}
            icon={iconButton}
            className="logo-container__button-menu"
          />
        </div>
        <div className="sidebar-wrapper__menu-items-list">
          {menuItems.map(
            ({ userCanView, active, link, icon, label }, index) => (
              <React.Fragment key={index}>
                {userCanView && (
                  <SidebarItem
                    menuIsOpen={menuIsOpen}
                    label={label}
                    active={active}
                    link={link}
                    icon={icon}
                  />
                )}
              </React.Fragment>
            ),
          )}
        </div>
        <div className="sidebar-wrapper__user-logout-list">
          <Link
            to="/usuarios/profile"
            className={`user-logout-list__avatar-user ${profile && 'user-logout-list__avatar-user-active'
              }`}
          >
            <Avatar base64={usuario?.arquivo} flHeader={true} size={30} />
            {menuIsOpen && (
              <div className="avatar-user">
                <h6>{usuario?.usuario}</h6>
                <p>{usuario?.perfil}</p>
                <p>{unidade?.descricao?.toUpperCase()}</p>
              </div>
            )}
          </Link>
          <div className={menuIsOpen ? 'sidebar-footer-open' : 'sidebar-footer'}>
            <SidebarItem
              menuIsOpen={menuIsOpen}
              label={t('menu:logout')}
              onClick={logout}
              icon={<Unicons.UilSignout />}
            />
           <LanguageDropdown />
          </div>
        </div>
      </aside>
    </>
  );
};
